import { useState, type ReactNode } from "react";
import { WebHeader } from "../../../../../shared/ui/WebHeader";
import { ActionsFrame } from "../../../../../shared/ui/PageActions";
import { useTranslation } from "../../i18n/useTranslation";
import { SUPPORT_HREF } from "../../lib/support";
import { ActionNoticeProvider, FooterRecaptchaNotice } from "../../../../../shared/ui/RecaptchaNotice";
// Lazy routes take the footer slot from ./AppFooterSecondary, never from this
// module: importing AppShell from a lazy route splits React out of the entry
// chunk (see ./footerTarget.ts).
import { FooterTarget } from "./footerTarget";

/** Eager, dependency-light chrome also used when a lazy route fails. */
export function AppShell({ children }: { children: ReactNode }) {
  const { locale, chooseLocale, t } = useTranslation();
  const [secondaryTarget, setSecondaryTarget] = useState<HTMLDivElement | null>(null);
  // One reCAPTCHA notice per screen: /login's action copy omits this footer's
  // (shared/ui/RecaptchaNotice.tsx).
  return <ActionNoticeProvider><div className="shell v3-shell">
    <FooterTarget.Provider value={secondaryTarget}><ActionsFrame className="v3-action-frame page v2" label={locale === "es" ? "Acciones" : "Actions"}>
      <WebHeader locale={locale} className="shell-top" />
      <div className="v3-app-scroll">
        <div className="shell-main">{children}</div>
        <footer className="shell-bot">
          <div className="v3-footer-secondary" ref={setSecondaryTarget} />
          <div className="v3-footer-meta"><div className="v3-legal-row">
            <div className="shell-language" role="group" aria-label="Language / Idioma">
              <button type="button" lang="en" aria-pressed={locale === "en"} onClick={() => chooseLocale("en")}>English</button>
              <button type="button" lang="es" aria-pressed={locale === "es"} onClick={() => chooseLocale("es")}>Español</button>
            </div>
            <nav aria-label={locale === "es" ? "Legal y ayuda" : "Legal and help"}>
              {/* Auth action URLs carry single-use codes. Never send their URL as a referrer. */}
              <a href="https://uselura.com/privacy/" target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer">{t("footer.privacy")}</a>
              <a href="https://uselura.com/terms/" target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer">{t("footer.terms")}</a>
              <a href={SUPPORT_HREF}>{t("footer.help")}</a>
            </nav>
          </div>
          {/* Google's reCAPTCHA disclosure, as its own footer row, unless the
              screen's protected action carries it. */}
          <FooterRecaptchaNotice locale={locale} />
          <p className="v3-publisher">Lura · Kindfield Works LLC</p></div>
        </footer>
      </div>
    </ActionsFrame></FooterTarget.Provider>
  </div></ActionNoticeProvider>;
}
